import BaseEntity from '@/core/misc/BaseEntity';
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES from "@/core/services/Changelogs/types";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Ед. изм. характеристики') // characteristicUnit → CharacteristicUnit
export default class CharacteristicUnit extends BaseEntity {
	static Events = {
		Created: 'characteristicUnit:created',
		Updated: 'characteristicUnit:updated',
		Deleted: 'characteristicUnit:deleted',
	} as const;

	@Title_ru_RU('Название', TYPES.STRING)
	name: string;

	static fromServer(data: any, result: CharacteristicUnit = new CharacteristicUnit()): CharacteristicUnit {
		super.fromServer(data, result);

		return result;
	}

  toString(): string {
    return this.name;
  }
}
